import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import {
  Trophy,
  CalendarDays,
  Users,
  Layers,
  Facebook,
  Instagram,
  Linkedin,
} from "lucide-react";

import Stats from "../components/Stats"; // keep this import

export default function Hero() {
  const [headerHeight, setHeaderHeight] = useState(90);
  const [bgImage, setBgImage] = useState("heroieee1.webp"); // default desktop image

  // Set header height
  useEffect(() => {
    const header = document.querySelector("header");
    if (header) setHeaderHeight(header.offsetHeight);
  }, []);

  // Update background image based on screen width
  useEffect(() => {
    const updateImage = () => {
      if (window.innerWidth < 768) {
        setBgImage("heroieee2.jpg"); // mobile
      } else {
        setBgImage("heroieee1.webp"); // desktop
      }
    };

    updateImage(); // initial check
    window.addEventListener("resize", updateImage); // update on resize

    return () => window.removeEventListener("resize", updateImage);
  }, []);

  const stats = [
    {
      number: 11,
      label: "Awards",
      icon: Trophy,
      color: "white",
      description: "Recognitions & Achievements",
      order: "order-1",
    },
    {
      number: 6,
      label: "Years",
      icon: CalendarDays,
      color: "blue",
      description: "Of Excellence",
      order: "order-2",
    },
    {
      number: 220,
      label: "Members",
      icon: Users,
      color: "white",
      description: "Active Community",
      order: "order-4 md:order-3",
    },
    {
      number: 7,
      label: "Subunits",
      icon: Layers,
      color: "blue",
      description: "Specialized Teams",
      order: "order-3 md:order-4",
    },
  ];

  return (
    <div className="relative bg-[#f4f7f9] w-full overflow-hidden">
      {/* HERO SECTION */}
      <div
        className="relative"
        style={{ height: `calc(100vh - ${headerHeight}px)` }}
      >
        {/* Background */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/${bgImage})` }}
        >
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#006699]/20 to-transparent" />
        </div>

        {/* SOCIAL ICONS */}
        <div
          className="
            absolute z-30 flex flex-col gap-3 sm:gap-5
            right-3 sm:right-6 md:right-8
            top-6 md:top-1/2
            md:-translate-y-1/2
          "
        >
          {[Facebook, Instagram, Linkedin].map((Icon, i) => (
            <motion.a
              key={i}
              href="#"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.4 + i * 0.1 }}
              whileHover={{ scale: 1.08, x: -4 }}
              className="
                cursor-pointer
                flex items-center justify-center
                w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12
                rounded-full
                bg-white/10 backdrop-blur-md
                border border-white/30
                hover:bg-[#0099cc]
                hover:border-[#0099cc]
                text-white shadow-lg transition-all duration-200
              "
            >
              <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-5 md:h-5" />
            </motion.a>
          ))}
        </div>
      </div>

      {/* STATS CARDS */}
      <div className="relative z-20 px-4 sm:px-6 md:px-16 lg:px-24 -mt-16 md:-mt-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <Stats stats={stats} />
        </div>
      </div>
    </div>
  );
}
